// UI imports
import './AdminManagement.scss';
import PublicPageLayout from "../../../layout/publicPageLayout/PublicPageLayout";
import {
    Card, CardBody, CardTitle,
    GridLayout,
    GridLayoutItem, TabStrip, TabStripSelectEventArguments, TabStripTab,
} from "@progress/kendo-react-layout";
import * as React from "react";
import Table from "../../../components/stateful/table/Table";
import AppUserManagement from './stateUserManagement/AppUserManagement';
import OfficialManagement from './officialMangement/OfficialManagement';
import UserSubManagement from './userSubManagement/UserSubManagement';


function AdminManagement() {
    const [selected, setSelected] = React.useState<number>(0);
    const handleSelect = (e: TabStripSelectEventArguments) => {
        setSelected(e.selected);
    };

    const renderAdminManagementView = () => {
        const columns = [
            "Agency / Title / Chapter Subscribed",
            "Date Subscribed",
            "Unsubscribe"
        ]

        return (
            <div className='body rule-management'>
              <GridLayout
                rows={[{ height: 90 }, { height: '100%' }]}
                 cols={[
                    { width: '20%' },
                    { width: '80%' },
                 ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2} className={'subscriptions-heading'}>
                <div>
                  <h2>Nebraska Administration Page</h2>
                  <hr />
                </div>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1} colSpan={2}>
                <TabStrip selected={selected} onSelect={handleSelect}>
                  <TabStripTab title='Manage Site Content'>
                    <Card className='card-container'>
                      <CardBody>
                        <CardTitle style={{ textAlign: 'center', color: '#3271E7' }}>
                          Manage Site Content
                        </CardTitle>
                        <Table columns={columns} height={'100%'} tableName={''} values={[]} />
                      </CardBody>
                    </Card>
                  </TabStripTab>
                  <TabStripTab title='Manage State Users'>
                    <Card className='card-container'>
                      <CardBody>
                        <CardTitle style={{ textAlign: 'center', color: '#3271E7' }}>
                          Manage State Users
                        </CardTitle>
                        <AppUserManagement />
                      </CardBody>
                    </Card>
                  </TabStripTab>
                  <TabStripTab title='Manage Government Officials'>
                    <Card className='card-container'>
                      <CardBody>
                        <CardTitle style={{ textAlign: 'center', color: '#3271E7' }}>
                          Manage Government Officials
                        </CardTitle>
                        <OfficialManagement />
                      </CardBody>
                    </Card>
                  </TabStripTab>
                  <TabStripTab title='Manage Subscription Users'>
                    <Card className='card-container'>
                      <CardBody>
                        <CardTitle style={{ textAlign: 'center', color: '#3271E7' }}>
                          Manage Subscription Users
                        </CardTitle>
                        <UserSubManagement />
                      </CardBody>
                    </Card>
                  </TabStripTab>
                </TabStrip>
              </GridLayoutItem>
            </GridLayout>
          </div>
        );
    }

    return (
        <PublicPageLayout>
            <div className="chapters-results">
                {renderAdminManagementView()}
            </div>

        </PublicPageLayout>
    )
}

export default AdminManagement;